import { useState, useEffect } from 'react';

import { CurrencyTypeEnum } from '../model/currency_type.enum';

const formatVolSeriesSavedIds = (item: any, oldCurrency: string, newCurrency: string) => {
  const obj = {
    ...item,
    id: item.id.replace(oldCurrency, newCurrency),
  };

  return obj;
};

const PATHS = (tab: string) => {
  return [
    { path: `SNAPSHOT/${tab}/type`, initialValue: '"VOLSURFACE"' },
    { path: `OVERVIEW/${tab}/range`, initialValue: '1D' },
    { path: `MARKET_DATA/${tab}/volSeriesSaved`, initialValue: [] },
    { path: `MARKET_DATA/${tab}/savedQueries`, initialValue: [] },
  ];
};

function usePersistentState<T>(
  path: string[],
  key: string,
  initialValue: T,
): [T, React.Dispatch<React.SetStateAction<T>>, boolean] {
  const storageKey = `${path.join('/')}/${key}`;

  const [state, setState] = useState<T>(() => {
    const storedValue = localStorage.getItem(storageKey);
    return storedValue !== null ? JSON.parse(storedValue) : initialValue;
  });

  const [hasBeenRead, setHasBeenRead] = useState<boolean>(false);

  useEffect(() => {
    if (localStorage.getItem(storageKey) !== null) {
      setHasBeenRead(true);
    }
  }, [storageKey]);

  useEffect(() => {
    try {
      const json = JSON.stringify(state);

      localStorage.setItem(storageKey, json);
    } catch (e) {
      console.error(e);
    }
  }, [storageKey, state]);

  return [state, setState, hasBeenRead];
}

export const importPersistentStateFromOtherTab = (
  oldTab: string,
  newTab: string,
  callback?: () => void,
) => {
  PATHS(oldTab).forEach((item, index) => {
    let storedValue = localStorage.getItem(item.path);

    if (storedValue && item.path.includes('volSeriesSaved')) {
      try {
        const storedObj = JSON.parse(storedValue);
        const fixedObj = storedObj.map((v: any) => formatVolSeriesSavedIds(v, oldTab, newTab));

        storedValue = JSON.stringify(fixedObj);
      } catch (err) {
        console.error(err);

        return;
      }
    }

    const json = storedValue || JSON.stringify(item.initialValue);
    const newPath = PATHS(newTab)[index].path;

    localStorage.setItem(newPath, json);

    if (callback) {
      callback();
    }
  });
};

export const clearTabPersistentState = (tab: CurrencyTypeEnum) => {
  PATHS(tab).forEach((item) => {
    localStorage.removeItem(item.path);
  });
};

export const getupdatedState = (path: string) => {
  const storedValue = localStorage.getItem(path);
  return storedValue !== null ? JSON.parse(storedValue) : null;
};

export default usePersistentState;
